export default function OwnerMyWallet() {
  return (
    <>
      <div className="main">
        <div className="topbar">
          <div>
            <div className="page-title" id="page-title">
              My Wallet
            </div>
            <div className="page-sub" id="page-sub">
              Coin balance, top-up &amp; transaction history
            </div>
          </div>
          <div className="topbar-right" id="topbar-right" />
        </div>
        <div className="content" id="content-area">
          {/* BALANCE HERO */}
          <div
            style={{
              background: "linear-gradient(135deg,#0F6E56 0%,#185FA5 100%)",
              borderRadius: "var(--radius-lg)",
              padding: "28px 32px",
              marginBottom: 20,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: 16,
            }}
          >
            <div>
              <div
                style={{
                  fontSize: 12,
                  color: "rgba(255,255,255,0.7)",
                  textTransform: "uppercase",
                  letterSpacing: ".08em",
                  marginBottom: 6,
                }}
              >
                🪙 Coin Balance — Sunrise Properties
              </div>
              <div
                style={{
                  fontSize: 42,
                  fontWeight: 800,
                  color: "#fff",
                  letterSpacing: "-1px",
                }}
              >
                2,400
              </div>
              <div
                style={{
                  fontSize: 12,
                  color: "rgba(255,255,255,0.7)",
                  marginTop: 4,
                }}
              >
                1 Coin = ₹1 · Last updated: Apr 18, 2025
              </div>
            </div>
            <div style={{ display: "flex", gap: 10 }}>
              <button
                onclick="openAddCoinModal()"
                style={{
                  background: "#fff",
                  color: "#0F6E56",
                  border: "none",
                  borderRadius: "var(--radius-md)",
                  padding: "10px 22px",
                  fontSize: 13,
                  fontWeight: 700,
                  cursor: "pointer",
                  fontFamily: "inherit",
                }}
              >
                + Add Coins
              </button>
              <button
                style={{
                  background: "rgba(255,255,255,0.15)",
                  color: "#fff",
                  border: "1px solid rgba(255,255,255,0.3)",
                  borderRadius: "var(--radius-md)",
                  padding: "10px 18px",
                  fontSize: 13,
                  fontWeight: 600,
                  cursor: "pointer",
                  fontFamily: "inherit",
                }}
              >
                📊 Ledger
              </button>
            </div>
          </div>
          <div className="stat-grid" style={{ marginBottom: 20 }}>
            <div className="stat-card">
              <div className="stat-icon">💰</div>
              <div className="stat-label">Total Added</div>
              <div className="stat-value">₹15,000</div>
              <div className="stat-delta delta-up">All time</div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">📤</div>
              <div className="stat-label">Total Used</div>
              <div className="stat-value">₹12,600</div>
              <div className="stat-delta delta-neu">SMS + WhatsApp</div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">📥</div>
              <div className="stat-label">Pending Requests</div>
              <div className="stat-value">₹5,000</div>
              <div className="stat-delta delta-neu">Awaiting approval</div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">✅</div>
              <div className="stat-label">Last Recharge</div>
              <div className="stat-value">₹5,000</div>
              <div className="stat-delta delta-up">Apr 15, 2025</div>
            </div>
          </div>
          <div className="two-col">
            <div className="card">
              <div className="card-title">Transaction History</div>
              <table>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Date</th>
                    <th>Description</th>
                    <th>Credit</th>
                    <th>Debit</th>
                    <th>Balance</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="sn-col">1</td>
                    <td>Apr 15</td>
                    <td>Wallet top-up (Bank Transfer)</td>
                    <td style={{ color: "var(--green)", fontWeight: 600 }}>
                      +5,000
                    </td>
                    <td>—</td>
                    <td>7,400</td>
                    <td>
                      <span className="badge badge-active">Approved</span>
                    </td>
                  </tr>
                  <tr>
                    <td className="sn-col">2</td>
                    <td>Apr 12</td>
                    <td>WhatsApp API usage — 480 msgs</td>
                    <td>—</td>
                    <td style={{ color: "var(--red)" }}>-240</td>
                    <td>2,400</td>
                    <td>
                      <span className="badge badge-info">Auto</span>
                    </td>
                  </tr>
                  <tr>
                    <td className="sn-col">3</td>
                    <td>Apr 10</td>
                    <td>SMS charges — 200 messages</td>
                    <td>—</td>
                    <td style={{ color: "var(--red)" }}>-100</td>
                    <td>2,640</td>
                    <td>
                      <span className="badge badge-info">Auto</span>
                    </td>
                  </tr>
                  <tr>
                    <td className="sn-col">4</td>
                    <td>Apr 01</td>
                    <td>Subscription renewal — Growth Plan</td>
                    <td>—</td>
                    <td style={{ color: "var(--red)" }}>-2,499</td>
                    <td>2,740</td>
                    <td>
                      <span className="badge badge-info">Auto</span>
                    </td>
                  </tr>
                  <tr>
                    <td className="sn-col">5</td>
                    <td>Mar 20</td>
                    <td>Wallet top-up (UPI)</td>
                    <td style={{ color: "var(--green)", fontWeight: 600 }}>
                      +5,000
                    </td>
                    <td>—</td>
                    <td>5,239</td>
                    <td>
                      <span className="badge badge-active">Approved</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="card">
              <div className="card-title">My Recharge Requests</div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "10px 0",
                  borderBottom: "0.5px solid var(--border-light)",
                }}
              >
                <div>
                  <div style={{ fontSize: 12, fontWeight: 600 }}>
                    UPI · ₹9,660
                  </div>
                  <div style={{ fontSize: 11, color: "var(--text-secondary)" }}>
                    Apr 17, 2025 · UTR: UTR123456789
                  </div>
                  <div style={{ fontSize: 10, color: "var(--text-tertiary)" }}>
                    April rent payment
                  </div>
                </div>
                <span className="badge badge-pending">Pending</span>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "10px 0",
                  borderBottom: "0.5px solid var(--border-light)",
                }}
              >
                <div>
                  <div style={{ fontSize: 12, fontWeight: 600 }}>
                    Bank Transfer · ₹11,200
                  </div>
                  <div style={{ fontSize: 11, color: "var(--text-secondary)" }}>
                    Apr 16, 2025 · UTR: UTR987654321
                  </div>
                  <div style={{ fontSize: 10, color: "var(--text-tertiary)" }}>
                    April rent + utilities
                  </div>
                </div>
                <span className="badge badge-active">Approved</span>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "10px 0",
                  borderBottom: "0.5px solid var(--border-light)",
                }}
              >
                <div>
                  <div style={{ fontSize: 12, fontWeight: 600 }}>
                    QR Code · ₹8,340
                  </div>
                  <div style={{ fontSize: 11, color: "var(--text-secondary)" }}>
                    Apr 15, 2025 · UTR: UTR456789123
                  </div>
                </div>
                <span className="badge badge-pending">Pending</span>
              </div>
              <button
                className="btn btn-sm"
                style={{ marginTop: 10 }}
                onclick="openAddCoinModal()"
              >
                + New Request
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
